import React, { useLayoutEffect } from 'react';
import styled from 'styled-components';
import Billboard from '../component/billboard/Billboard';
import { useBillboardStore } from '../shared/store/billboardStore';
import { useShortCut } from '../shared/hooks/useShortCut';
import { usePageOwnerIdentityStore } from '../shared/store/pageOwnerIdentityStore';
import { useParams } from 'react-router-dom';

const BillboardArchive: React.FC = () => {
  const clearBillboard = useBillboardStore((s) => s.clearBillboard);
  const { handleCmdE } = useShortCut();
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);
  const { HANDLE: raw } = useParams<{ HANDLE?: string }>();

  // 페이지 소유자가 바뀌면 이전 소유자의 billboard를 비운다.
  useLayoutEffect(() => {
    clearBillboard();
  }, [raw, pageOwner?.aui]);

  return (
    <BillboardPage
      onKeyDown={(e) => handleCmdE(e)}
      tabIndex={-1}
    >
      <Billboard />
    </BillboardPage>
  );
}

const BillboardPage = styled.main`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`

export default BillboardArchive;
